import React from "react";

interface ToolbarButtonProps {
	onClick: (e: React.MouseEvent<HTMLButtonElement>) => void;
	isActive?: boolean;
	disabled?: boolean;
	icon: React.ComponentType<{ className?: string }>;
	label: string;
	className?: string;
}

const baseClass =
	"p-1 border rounded-md text-sm font-medium disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 flex items-center justify-center";

const defaultButtonClass = "border-gray-300 bg-white hover:bg-gray-50 hover:border-gray-400 active:bg-gray-100";

const activeClass = "border-primary-main bg-primary-main/10 text-primary-main";

export const ToolbarButton: React.FC<ToolbarButtonProps> = ({
	onClick,
	isActive = false,
	disabled = false,
	icon: Icon,
	label,
	className = "",
}) => {
	// Check if custom background/border classes are provided
	const hasCustomStyling = className.includes("bg-") || className.includes("border-");

	return (
		<button
			type="button"
			onClick={onClick}
			disabled={disabled}
			className={`${baseClass} ${!hasCustomStyling && !isActive ? defaultButtonClass : ""} ${isActive ? activeClass : ""} ${className}`}
			title={label}
			aria-label={label}
		>
			<Icon className="w-4 h-4" />
		</button>
	);
};

export const ToolbarDivider: React.FC = () => <div className="w-px h-8 bg-gray-300 mx-1" />;

export const ToolbarGroup: React.FC<{ children: React.ReactNode }> = ({ children }) => (
	<div className="flex items-center gap-1">{children}</div>
);


